import styled from 'styled-components';

export const TextContainer = styled.div`
  word-break: keep-all;
  line-height: 134%;
`;
